export enum SchoolAdminStatus{
    Active,
    Inactive
}